import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { pick } from 'ramda';
import { useAppSelector } from 'js/store/hooks';
import { userSetAttributesAction, userUnsetAttributesAction } from 'js/hooks/user/store/actions';
import { useHandleActions } from 'js/components/system/App/hooks';

import * as server from '../server';
import { useGetSubscriptionActionTypes } from './useGetSubscriptionActionTypes';

export const useSuccessLoginAction = () => {
    const dispatch = useDispatch();
    const startWindowSession = useStartWindowSession();
    const handleActions = useHandleActions();

    return useCallback(async (userParams) => {
        const windowSessionId = Math.floor(Math.random() * 100000000);

        dispatch(userUnsetAttributesAction('password'));
        dispatch(userSetAttributesAction({
            role: 'user',
            isLoggedIn: true,
            hasBeenLoggedIn: true,
            isSessionStarted: false,
            windowSessionId,
            ...userParams
        }));

        const response = await startWindowSession(windowSessionId);
        const { actions = [] } = response.data;

        await handleActions(actions, { windowSessionId });

        dispatch(userSetAttributesAction({
            isSessionStarted: true
        }));

        }, [dispatch, startWindowSession, handleActions]);
};

export const useStartWindowSession = () => {
    const subscriptionActionTypes = useGetSubscriptionActionTypes();
    const {
        sessionSubscriptionTags = '',
        sessionSubscriptionBalances = '',
        // 123 -- AgeVerificationStatus
        sessionSubscriptionRequestedPlayerData = '123'
    } = useAppSelector(pick([
        'sessionSubscriptionTags',
        'sessionSubscriptionBalances',
        'sessionSubscriptionRequestedPlayerData'
    ]));

    return useCallback((windowSessionId) => {
        const subscriptionTags = sessionSubscriptionTags
            .split(',')
            .map(tag => tag.trim())
            .concat(['uam/hidden/playerRecentGames']);
        const subscriptionBalanceTypes = sessionSubscriptionBalances
            .split(',')
            .map(type => type.trim());
        const subscriptionRequestedPlayerData = sessionSubscriptionRequestedPlayerData
            .split(',')
            .map(type => type.trim());

        return server.startWindowSession({
            windowSessionId,
            subscriptionTags,
            subscriptionActionTypes,
            subscriptionBalanceTypes,
            subscriptionRequestedPlayerData
        });
    }, [sessionSubscriptionTags, subscriptionActionTypes, sessionSubscriptionBalances, sessionSubscriptionRequestedPlayerData]);
};
